import { FadeUp } from "./Reveal";

const QUOTES = [
  {
    quote: "They photographed our wedding like a film we get to live inside forever. We cried before we even reached the tenth frame.",
  },
  {
    quote: "No stiff poses, no interruptions. Just us — exactly as the day felt. The gallery is the most beautiful thing we own.",
  },
  {
    quote: "Every photographer shows you how your wedding looked. TapeShift Weddings showed us how it felt. There's a difference, and it's everything.",
  },
];

export const Testimonials = () => (
  <section id="stories" className="px-6 md:px-12 py-28 md:py-44 bg-[#0A0A0A]" data-testid="testimonials-section">
    <FadeUp className="mb-16 md:mb-24">
      <p className="text-xs tracking-[0.4em] uppercase text-[#C9A26B] mb-4">Love Notes</p>
      <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#F5F4F0] leading-[1.05]">
        In their <span className="font-accent italic text-[#C9A26B]">own words</span>
      </h2>
    </FadeUp>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
      {QUOTES.map((q, i) => (
        <FadeUp key={i} delay={i * 0.1}>
          <blockquote
            data-testid={`testimonial-${i}`}
            className={`flex flex-col h-full ${i === 1 ? "md:pt-16" : ""} ${i === 2 ? "md:pt-32" : ""}`}
          >
            <span className="font-accent text-7xl leading-none text-[#C9A26B]/40 select-none mb-6">"</span>
            <p className="font-serif font-light text-xl md:text-2xl leading-relaxed text-[#F5F4F0] flex-1">
              {q.quote}
            </p>
            <span className="mt-10 block w-12 h-px bg-[#C9A26B]/60" />
          </blockquote>
        </FadeUp>
      ))}
    </div>
  </section>
);
